<template>
  <!-- Search Filter Section -->
  <section
    class="car-search-filter aos"
    data-aos="fade-up"
    data-aos-delay="400"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="car-filter-section">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  All Conditions
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  New Cars
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-contact-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-contact"
                  type="button"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                >
                  Used Cars
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-certified-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-certified"
                  type="button"
                  role="tab"
                  aria-controls="pills-certified"
                  aria-selected="false"
                >
                  Certified
                </button>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabindex="0"
              >
                <indexsixfiltercontent />
              </div>
              <div
                class="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
                tabindex="0"
              >
                <indexsixfiltercontent />
              </div>
              <div
                class="tab-pane fade"
                id="pills-contact"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
                tabindex="0"
              >
                <indexsixfiltercontent />
              </div>
              <div
                class="tab-pane fade"
                id="pills-certified"
                role="tabpanel"
                aria-labelledby="pills-certified-tab"
                tabindex="0"
              >
                <indexsixfiltercontent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Search Filter Section -->
</template>
